//wrap Cytoscape.js

import Vue from 'vue'
import cytoscape from 'cytoscape';
import dagre from 'cytoscape-dagre';
cytoscape.use(dagre); //include layout algorithms
// import cola from 'cytoscape-cola';
// cytoscape.use(cola );

// import Util from '@/common/Util';
// import Task from '@/common/Task';
// import DateTime from '@/common/DateTime';
// import store from '@/store/Store';

export default class Cytoscape{
  constructor(){

    this.hasrun = false; //layout doesn't run/work on first draw, so add a delay

    //constructor makes the class data members
    this.cyt = cytoscape( { style: cytoStyle });
    // console.log('cytoscape constructed:');

    this.cyt.ready( ()=>{
      Vue.$log.info('Cytoscape is ready()');

      setTimeout( ()=>{ //delay the mount until the container is definitely there...
        let cnt = document.getElementById('cytoscapeContainer'); // container to render in, created in App.vue
        this.cyt.mount( cnt ); // container to render in
        // console.log('mounted to container: ', cnt);
      }, 1000 );

      this.cyt.minZoom( 0.8 );
      this.cyt.maxZoom( 3.0 );

    }); //ready

    this.cyt.on('render', ()=>{ //put these after render to ensure they have effect...but this has the effect of keeping the nodes always on the page
      this.cyt.resize();
      // this.cyt.center(); //really want to do these only if no nodes are visible...
      // this.cyt.fit();
    });
    // this.cyt.on('zoom', ()=>{
    //   // Vue.$log.info('cytoscape zoom is ', this.cyt.zoom());
    //   this.cyt.resize();
    // });
  }//construct

  drawGraph( nodeArray, edgeArray ){
    Vue.$log.info('Cyto.drawGraph');
    this.clearGraph(); //essential to clean out old tasks, else ids collide
    // console.log('nodeArray is ', nodeArray );
    // console.log('edgeArray is ', edgeArray );

    for (let n of nodeArray){ //add nodes
      let newNode = { group: 'nodes', data:{
        id: n.id,
        name: n.name,
        backgroundColor: n.style.fill,
        borderColor: n.style.stroke,
        textColor: n.style.text,
        position:{x:0, y:0}
      }}
      // console.log( 'adding node [' + newNode.data.id + '] ' + newNode.data.name, newNode );

      try{
        this.cyt.add(newNode);
      } catch(err) {
        console.log('Cytsocape.drawGraph had error', err );
      }
    }

    for (let ed of edgeArray){ //add edges
      let edge = { group: 'edges', data: {
        id: ed.uuid,
        source: ed.source,
        target: ed.target,
        // line-color: ed.linecolor //hint DoNow/Gantt via line colors?
      }};
      try{
        this.cyt.add( edge );
      } catch(err) {
        console.log('Cytsocape.drawGraph had error', err );
      }
    }

    //layout doesn't run/work on first draw, so add a delay
    if (this.hasrun){
      this.lay = this.cyt.layout( layopts );
      this.lay.run();
    } else {
      setTimeout( ()=> {
        this.lay = this.cyt.layout( layopts );
        this.lay.run();
        this.hasrun = true;
      }, 1000 );
    }
  }

  clearGraph(){
    let nodes = this.cyt.elements();
    // console.log('nodes',nodes);
    for (let n of nodes){
      n.remove();
    }
  }

  getDFS(){//get a DFS of the nodes .. this is very broken
    let dfsNodes = [];
    let nodes = this.cyt.elements('nodes');
    // console.log('nodes',nodes);
    // let edges = this.cyt.elements('edges');
    // console.log('edges',edges);

    nodes.unselect();
    let dfs = nodes.depthFirstSearch({
    // let dfs = nodes.breadthFirstSearch({
    // let dfs = edges.depthFirstSearch({
      // root:'#"do thing a"', //yes
      root: nodes[0].id(), // start at the first node
      // visit: (v,e,u,i,d)=>{
      visit: (v)=>{
        // console.log({v:v.data('name'), e:e, u:u, i:i, d:d})
        dfsNodes.push(v.data('name'));
        // console.log(d + ' | ' + i + ' | ' +  v.data('name') + ' | ' + v.id(),v);
        // if (u!=undefined){
        //   console.log(d + ' | ' + i + ' | ' +  u.id() + ' --> ' + v.id());
        // }
      },
      directed:true
    });
    console.log('dfs', dfs);
    console.log('dfs', dfsNodes);
    // console.log('return false');
    console.error('Cytoscape DFS is incorrect');
    return dfsNodes;
  }

  getGraphJSON(){
    return this.cyt.json();
  }
  setGraphFromJSON( graphJSON ){
    this.cyt.json( graphJSON );
  }

}//Cytoscape

// the stylesheet for the graph, see http://js.cytoscape.org/#style/node-body
let cytoStyle = [
  {
    selector: 'node',
    style: {
      //styling the node body, this is the handle shape beneath the label
      'shape': 'rectangle',
      'width': 'label', //make the node width == label width
      'height': 'label', //make the node width == label width
      'background-opacity': 0.0,
      'padding': '5px',//padding outside node, inflating the node so the arrow terminates _px away
      'label': 'data(name)',
      'font-size': '12', //given zooming, this is relative to the rectangle and graph size
      'text-halign': 'center',
      'text-valign': 'center',
      'font-family': 'Arial',
      'min-zoomed-font-size': '5', //determines when labels are drawn, doesn't limit zoom
      'text-border-width': '2px',
      'text-border-style': 'solid',
      'text-border-opacity': 0.5,
      'color': function(elem){ return elem.data('textColor'); },
      'text-border-color': function(elem){ return elem.data('borderColor'); },
      'text-background-shape': 'roundrectangle',
      'text-background-padding': '2px',
      'text-background-opacity': 0.9,
      'text-background-color': function(elem){ return elem.data('backgroundColor'); }
    }
  },
  {
    selector: 'edge',
    style: {
      'width': '2px',
      'line-color': '#999',
      'target-arrow-color': '#999',
      'target-arrow-shape': 'triangle',
      // 'curve-style': 'haystack', 'haystack-radius': 10
      'curve-style': 'bezier' //doesn't make curves..
      // 'curve-style': 'taxi'
      // 'curve-style': 'unbundled-bezier', 'control-point-step-size':'0.0 0.5 0.5', 'control-point-distances':'05% 50% 95%', 'control-point-weight':'0.8' //edges sometimes disappear with this
    }
  }
];

// let layopts = {
//   name: 'grid',
//   padding: 30,
//   avoidOverlap: true,
//   avoidOverlapPadding: 100, //
//   // avoidOverlapPadding: '10px', //no nodes visible
//   nodeDimensionsIncludeLabels: true,
//   condense: true
// };
// let layopts = {//doesn't respect edge direction, arranges all in fat rows
//   name: 'breadthfirst',
//   padding: 3,
//   avoidOverlap: true,
//   spacingFactor: 0.5,
//   nodeDimensionsIncludeLabels: true,
// };
// let layopts = {
//   name: 'cose',
//   padding: 1,
//   componentSpacing: 1,
//   nodeOverlap: 1,
//   nodeDimensionsIncludeLabels: true,
// };
let layopts = {
  name: 'dagre', // https://github.com/cytoscape/cytoscape.js-dagre
  // ranker: 'network-simplex', // algorithm to rank to each node in the input graph: 'network-simplex', 'tight-tree' or 'longest-path'
  ranker: 'tight-tree',
  // ranker: 'longest-path',
  fit: false, //don't fit the graph to the window on draw
  rankDir: 'LR', // 'TB' for top to bottom flow, 'LR' for left to right,
  rankSep: 2, //the separation between each rank in the layout
  nodeSep: 2, // the separation between adjacent nodes in the same rank
  edgeSep: 2, // thee separation between adjacent edges in the same rank
  // minLen: function( edge ){ return 10; }, // number of ranks to keep between the source and target of the edge
  edgeWeight: function( edge ){ // higher weight edges are generally made shorter and straighter than lower weight edges
    return 1/(1+edge.weight);
  },
  nodeDimensionsIncludeLabels: true,
};
// let layopts = {
//   name: 'cola',
//   animate: true,
//   refresh: 10,
//   maxSimulationTime: 100000, //ms
//   ungrabifyWhileSimulating: true,
//   fit:true,
//   padding: 10, //extra padding around the nodes from the page edges
//   nodeDimensionsIncludeLabels: true,
//   avoidOverlap: true,
//   flow: {axis: 'x', minSeparation: 30}
//   };
